import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styled from 'styled-components';
import { SyncLoader } from 'react-spinners';
import { brandingColourHeavy, loadingZIndex } from '../appComponents/cssConstants';

// TODO: The loading animation is not in the screen center now when the page has large height.
// Default to `body` as all grids have 100% height at the moment.
// Need pass in '.k-grid-content' or '.k-grid' if want to show loading on grid only.
const Loading = (props: Props) => {
	const { loadingPosition = '#app' } = props;
	const override: React.CSSProperties = {
		opacity: 0.7
	};
	const panel = (
		<LoadingMask className="k-loading-mask">
			<span className="k-loading-text">Loading</span>
			<SyncLoader
				color={brandingColourHeavy}
				loading
				size={15}
				aria-label="Loading Spinner"
				data-testid="loader"
				cssOverride={override}
				speedMultiplier={0.75}
			/>
			<Overlay className="k-loading-color" />
		</LoadingMask>
	);

	const grid = document.querySelector(loadingPosition);
	if (!grid) return panel;
	return ReactDOM.createPortal(panel, grid);
};

interface Props {
	loadingPosition?: string;
}

export default Loading;

const Overlay = styled.div`
	background: none;
`;

const LoadingMask = styled.div`
	z-index: ${loadingZIndex};
	width: 100vw;
	height: 100vh;
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	touch-action: none;
	overscroll-behavior: contain;
`;
